import {
    IB_ACCOUNT_RULES_FETCH,
    IB_ACCOUNT_RULES_IS_FETCING,
    IB_ACCOUNT_RULE_FILTER,
    IB_ACCOUNT_RULE_EDIT,
    SET_IB_ACCOUNT_RULE_PROFILE,
    SET_IB_ACCOUNT_RULE_IB
} from 'constants/ibAccountRules'

export default function ibAccountRulesReducer(state = {
    list: [],
    pageable: {
        sort: {
            'ibAccountRuleId': 'asc',
        },
        filter: {},
        size: 10,
        page: 0,
        totalPages: 0,
        totalElements: 0,
    }
}, action) {
    switch (action.type) {
        case IB_ACCOUNT_RULES_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case IB_ACCOUNT_RULE_EDIT:
            return {
                ...state,
                // list: state.list.find(e=>state.ibAccountRuleId===e.ibAccountRuleId)?,
            }
        case IB_ACCOUNT_RULES_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
            }
        case SET_IB_ACCOUNT_RULE_PROFILE:
          return {
              ...state,
              selectedProfileId: action.payload.profileId,
              selectedProfileName: action.payload.profileName
          }
        case SET_IB_ACCOUNT_RULE_IB:
          return {
              ...state,
              selectedIbId: action.payload.ibId,
              selectedIbName: action.payload.ibName
          }
        case IB_ACCOUNT_RULE_FILTER:
            return {
                ...state,
                pageable: {
                    ...state.pageable,
                    ...action.payload,
                    sort: action.payload.sort ? {
                        ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                            ...obj,
                            [i]: false
                        }), {}),
                        ...action.payload.sort
                    } : state.pageable.sort,
                },
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ibAccountRules.js